import { useTranslate } from 'hooks/useTranslate';
import { setModal } from 'modules/_shared/redux/modalActions';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

const SendEmailHeader: FC = () => {
  const { t } = useTranslate();

  const dispatch = useDispatch();

  return (
    <Modal.Header>
      <h5 className="modal-title mb-0">
        <em className="icon icon-circle ni ni-send bg-primary-alt mr-2" />
        {t('NewCommunication')}
      </h5>
      <a
        className="close cursor-pointer"
        onClick={() => dispatch(setModal(null))}
      >
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default SendEmailHeader;
